import * as Sebrae from '@sebrae/react-core';
import React, { createContext, useContext } from 'react';

import { ENDPOINT_CLASS_ROOM_PARTICIPANTS } from '../../../hooks/services/constants';


export const TableParticipantsContextNew = createContext();

export const TableParticipantsProviderNew = ({ children, idTurma }) => {
  const { fetchData, data, loading, error } = Sebrae.usePagination(
    `${ENDPOINT_CLASS_ROOM_PARTICIPANTS}/${idTurma}/participants`,
  );
  return (
    <TableParticipantsContextNew.Provider
      value={{
        fetchData,
        data,
        loading,
        error,
      }}
    >
      {children}
    </TableParticipantsContextNew.Provider>
  );
};

export const useTableParticipants = () => {
  const context = useContext(TableParticipantsContextNew);
  if (!context) {
    throw new Error(
      'useTableCandidate deve ser usado dentro de um TableCandidateProvider',
    );
  }
  return context;
};
